/* globals jQuery */
import 'fitvids.1.1.0'
import 'flexslider'
import 'magnific-popup'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //OPEN SEARCH POPUP
	$('.open-search').magnificPopup({
	  type:'inline',
	  alignTop: true,
	  midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	  mainClass: 'mfp-fade'
	});
	$(document).on('click', '.close-search', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

    //OPEN LOGIN POPUP
    $('.js-login-popup').magnificPopup({
        type: 'inline',
        alignTop: true,
        midClick: true,
        mainClass: 'mfp-fade'
    });
    $(document).on('click', '.close-popup', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

    //main hero slideshow
    $('.slideshow.flexslider').flexslider({
        directionNav: false
    });

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // RESPONSIVE VIDEOS
    $('.rtecontent').fitVids();

    // ACCORDIONS
    $('dl.accordion').accordion();

    //ALERT MESSAGES
    //Message hide trigger
    window.addEventListener('DOMContentLoaded', function() {

        var bar = $('.js-global-alert.alert-message'),
            closeBtn = $('.js-global-alert.alert-message .message-hide');

        closeBtn.click(function (e) {
            //Fade out message text and close button
            e.preventDefault();
            $(this).parent().prev('.alert-message__column2').addClass("fade");
            $(this).closest('.alert-message__column3').addClass("fade");

            //Slide up message
            $(this).closest('.alert-message').delay(300).slideUp('slow', 'swing');

            // persist the dismissal in a cookie
            document.cookie = closeBtn.data('alert-cookie');

        });
    });



    //LOCATIONS
    var mapArchive = document.getElementById('location-archive-map');
    var mapSingle = document.getElementById('location-single-map');

    if (mapArchive || mapSingle) {
        //console.log(WineryMap);
        var LocationMapClass = require('./location-map.js');

        if( mapArchive ){
        	var LocationMap = new LocationMapClass(mapArchive);
            LocationMap.initMap(true, true);
        }
        else if( mapSingle ){
            var LocationMap = new LocationMapClass(mapSingle);
            LocationMap.initMap(false, false);
        }

    }

})(jQuery)
